import { config, resolveEmailAttributionEnabled } from '@littlebird/sdk';
import { reaction } from 'mobx';
import { useEffect, useState } from 'react';

import { subscriptionStore } from '@/features/subscription/subscription.store';
import { userStore } from '@/stores/user.store';

function getEmailAttributionEnabled(): boolean {
  return resolveEmailAttributionEnabled(
    config.chat.email_attribution_footer_enabled,
    {
      isPaid: subscriptionStore.isActive,
      isInternalUser: userStore.isInternalUser,
    }
  );
}

export function useEmailAttributionEnabled(): boolean {
  const [enabled, setEnabled] = useState(getEmailAttributionEnabled);

  useEffect(
    () =>
      reaction(getEmailAttributionEnabled, setEnabled, {
        fireImmediately: true,
      }),
    []
  );

  return enabled;
}
